import { createSelector, createFeatureSelector } from '@ngrx/store';

import { LegalRestrictionState } from '../legal-restriction.model';

export const selectLegalRestrictionState =
  createFeatureSelector<LegalRestrictionState>('legalRestriction');

export const selectLegalRestrictions = createSelector(
  selectLegalRestrictionState,
  (state) => state?.legalRestrictions || [],
);

export const selectLegalRestriction = (cropAidId: number, cropId: number) =>
  createSelector(selectLegalRestrictions, (legalRestrictions) =>
    legalRestrictions.find(
      (legalRestriction) =>
        legalRestriction.cropAidId === cropAidId && legalRestriction.cropId === cropId,
    ),
  );
